import { AppAction, AppData } from "@Safemate/Store/types";
import { select, takeLatest } from "redux-saga/effects";
import { UserAdminActionTypes } from "../actionTypes";
import { selectAppData } from "@Safemate/Store/selectors";
import { saveFilters } from "../utils";
import { FilterState } from "../types";
import { getFilters } from "../selectors";

function* setFilters(action: AppAction<null>){         

  
  const filters: FilterState = yield select(getFilters);
  console.log(filters)

  const appData: AppData = yield select(selectAppData);
  const roleId = appData.activeRoles.length > 0 ? appData.activeRoles[0].id : 0;
  const userId = appData.user.id;
  saveFilters(filters, roleId, userId);
}

function* filterSaga(){
  yield takeLatest(UserAdminActionTypes.FILTER_CUSTOMER, setFilters);
  yield takeLatest(UserAdminActionTypes.FILTER_SEARCH, setFilters);
  yield takeLatest(UserAdminActionTypes.FILTER_ORDER, setFilters);
  yield takeLatest(UserAdminActionTypes.FILTER_ROLE, setFilters);
  yield takeLatest(UserAdminActionTypes.FILTER_STATUS, setFilters);
}

export default filterSaga;
